// extracted by mini-css-extract-plugin
export var box = "RadioBtn-module--box--ffa35";
export var box_md = "RadioBtn-module--box_md--3e4b2";
export var box_xmd = "RadioBtn-module--box_xmd--daf5e";
export var box_flex = "RadioBtn-module--box_flex--6f1f3";
export var box_lg = "RadioBtn-module--box_lg--58e4a";
export var box_sm = "RadioBtn-module--box_sm--24bb0";
export var box_outer = "RadioBtn-module--box_outer--67ae1";
export var box_whiteBg = "RadioBtn-module--box_white-bg--a0d18";
export var box_noMarginBottom = "RadioBtn-module--box_no-margin-bottom--82d65";
export var box_noPadding = "RadioBtn-module--box_no-padding--756f4";
export var box_outerGray = "RadioBtn-module--box_outer-gray--e6399";
export var box_dark = "RadioBtn-module--box_dark--e3503";
export var box_zIndex = "RadioBtn-module--box_z-index--d4655";
export var box_zIndex6 = "RadioBtn-module--box_z-index-6--16d7a";
export var box_eventsWithLine = "RadioBtn-module--box_events-with-line--e90d8";
export var box_featuresAo = "RadioBtn-module--box_features-ao--127d0";
export var box_verticalPaddings = "RadioBtn-module--box_vertical-paddings--a686a";
export var clearP = "RadioBtn-module--clearP--1ac9e";
export var clearP_vc = "RadioBtn-module--clearP_vc--b5354";
export var radio = "RadioBtn-module--radio--b7457";
export var checkmark = "RadioBtn-module--checkmark--cd99e";
export var input = "RadioBtn-module--input--64205";
export var name = "RadioBtn-module--name--27b83";
export var fadeInAnimation = "RadioBtn-module--fadeInAnimation--63429";
export var placeHolderShimmer = "RadioBtn-module--placeHolderShimmer--41988";